module.exports = __webpack_public_path__ + "img/model_53_ug.87ca1904.jpg";